// extracted by mini-css-extract-plugin
export default {"container":"Tips_container__fpvlP"};